module.exports = __webpack_public_path__ + "assets/img/mecha-detail-btn-e6ab58d0.png";